/* index.js */

"use strict";

module.exports = {
    LogsControlComponent: require("./logs_control/LogsControlComponent"),
};
